var _linearGradient, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppleTestFlight = function SvgAppleTestFlight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "test-flight-a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#25C7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1D70F2"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "test-flight-b",
    d: "M12 23.875C5.442 23.875.125 18.558.125 12S5.442.125 12 .125 23.875 5.442 23.875 12 18.558 23.875 12 23.875zm0-.75c6.144 0 11.125-4.98 11.125-11.125S18.145.875 12 .875.875 5.855.875 12 5.855 23.125 12 23.125z",
    style: {
      fill: "#FFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#test-flight-a)",
    d: "M20.843 0c3.213 0 4.819 0 6.548.547a6.796 6.796 0 0 1 4.062 4.062C32 6.338 32 7.944 32 11.157v9.686c0 3.213 0 4.819-.547 6.548a6.795 6.795 0 0 1-4.062 4.062c-1.73.547-3.335.547-6.548.547h-9.686c-3.213 0-4.82 0-6.548-.547a6.795 6.795 0 0 1-4.062-4.062C0 25.661 0 24.056 0 20.843v-9.686c0-3.213 0-4.82.547-6.548A6.796 6.796 0 0 1 4.609.547C6.338 0 7.944 0 11.157 0h9.686z",
    style: {
      fill: "url(#test-flight-a)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.45,
    transform: "translate(4 4)"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "evenodd",
    xlinkHref: "#test-flight-b"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.5,
    d: "M12 24.125C5.304 24.125-.125 18.696-.125 12S5.304-.125 12-.125 24.125 5.304 24.125 12 18.696 24.125 12 24.125zm0-1.25c6.006 0 10.875-4.869 10.875-10.875S18.006 1.125 12 1.125 1.125 5.994 1.125 12 5.994 22.875 12 22.875z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.787 17.411l-6.063 3.973a.253.253 0 0 1-.353-.085l-.322-.558a.25.25 0 0 1-.006-.011.25.25 0 0 1 .109-.337l6.472-3.263.163.281zm-8.037 4.08l.322.558a1 1 0 0 0 1.366.366 1 1 0 0 0 .044-.026l7.31-4.736-.875-1.516-7.756 3.964a1 1 0 0 0-.435 1.345 1 1 0 0 0 .024.045zm12.48-4.08l6.062 3.973c.13.076.284.035.353-.085l.322-.558a.25.25 0 0 0 .006-.011.25.25 0 0 0-.109-.337l-6.472-3.263-.163.281zm8.036 4.08l-.322.558a1 1 0 0 1-1.366.366 1 1 0 0 1-.044-.026l-7.31-4.736.875-1.516 7.756 3.964a1 1 0 0 1 .436 1.345 1 1 0 0 1-.025.045zm-9.979-8.241l.41-7.237a.253.253 0 0 0-.25-.263h-.644a.25.25 0 0 0-.013 0 .25.25 0 0 0-.237.263l.41 7.237h.324zm-.484-9h.644a1 1 0 0 1 1 1 1 1 0 0 1 0 .051L17 14h-1.75l-.446-8.699a1 1 0 0 1 .947-1.05 1 1 0 0 1 .052-.001z",
    style: {
      fill: "#FFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 17.75a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75zm0 .75a2.625 2.625 0 1 1 0-5.25 2.625 2.625 0 0 1 0 5.25z",
    style: {
      fill: "#FFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.125 15.521l.323-.323a.25.25 0 1 1 .354.354l-.323.323.323.323a.25.25 0 1 1-.354.354l-.323-.323-.323.323a.25.25 0 1 1-.354-.354l.323-.323-.323-.323a.25.25 0 1 1 .354-.354l.323.323z",
    opacity: 0.242,
    style: {
      fill: "#FFF"
    }
  }))));
};
export default SvgAppleTestFlight;